"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LottieLoader = exports.Container = void 0;

var _lottieReact = _interopRequireDefault(require("lottie-react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _theme = require("../../theme");

const Container = _styledComponents.default.div.withConfig({
  displayName: "PlatformLoaderstyles__Container"
})(["width:", ";height:", ";max-width:100%;max-height:100%;min-width:0;min-height:0;display:flex;justify-content:center;align-items:center;canvas{width:", ";height:auto;}img{opacity:0;pointer-events:none;height:0;width:0;}"], _ref => {
  let {
    size
  } = _ref;
  return (0, _theme.rem)(size);
}, _ref2 => {
  let {
    size
  } = _ref2;
  return (0, _theme.rem)(size);
}, _ref3 => {
  let {
    size
  } = _ref3;
  return (0, _theme.rem)(size);
});

exports.Container = Container;
const LottieLoader = (0, _styledComponents.default)(_lottieReact.default).withConfig({
  displayName: "PlatformLoaderstyles__LottieLoader"
})(["width:100%;height:100%;"]);
exports.LottieLoader = LottieLoader;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJDb250YWluZXIiLCJzdHlsZWQiLCJkaXYiLCJzaXplIiwicmVtIiwiTG90dGllTG9hZGVyIiwiTG90dGllIl0sInNvdXJjZXMiOlsiLi4vLi4vLi4vc3JjL2NvbXBvbmVudHMvUGxhdGZvcm1Mb2FkZXIvUGxhdGZvcm1Mb2FkZXIuc3R5bGVzLnRzIl0sInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBMb3R0aWUgZnJvbSAnbG90dGllLXJlYWN0J1xuaW1wb3J0IHN0eWxlZCBmcm9tICdzdHlsZWQtY29tcG9uZW50cydcbmltcG9ydCB7IHJlbSB9IGZyb20gJ350aGVtZSdcblxuZXhwb3J0IGNvbnN0IENvbnRhaW5lciA9IHN0eWxlZC5kaXY8eyBzaXplOiBudW1iZXIgfT5gXG4gIHdpZHRoOiAkeyh7IHNpemUgfSkgPT4gcmVtKHNpemUpfTtcbiAgaGVpZ2h0OiAkeyh7IHNpemUgfSkgPT4gcmVtKHNpemUpfTtcbiAgbWF4LXdpZHRoOiAxMDAlO1xuICBtYXgtaGVpZ2h0OiAxMDAlO1xuICBtaW4td2lkdGg6IDA7XG4gIG1pbi1oZWlnaHQ6IDA7XG4gIGRpc3BsYXk6IGZsZXg7XG4gIGp1c3RpZnktY29udGVudDogY2VudGVyO1xuICBhbGlnbi1pdGVtczogY2VudGVyO1xuXG4gIGNhbnZhcyB7XG4gICAgd2lkdGg6ICR7KHsgc2l6ZSB9KSA9PiByZW0oc2l6ZSl9O1xuICAgIGhlaWdodDogYXV0bztcbiAgfVxuXG4gIGltZyB7XG4gICAgb3BhY2l0eTogMDtcbiAgICBwb2ludGVyLWV2ZW50czogbm9uZTtcbiAgICBoZWlnaHQ6IDA7XG4gICAgd2lkdGg6IDA7XG4gIH1cbmBcblxuZXhwb3J0IGNvbnN0IExvdHRpZUxvYWRlciA9IHN0eWxlZChMb3R0aWUpYFxuICB3aWR0aDogMTAwJTtcbiAgaGVpZ2h0OiAxMDAlO1xuYFxuIl0sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7QUFBQTs7QUFDQTs7QUFDQTs7QUFFTyxNQUFNQSxTQUFTLEdBQUdDLHlCQUFBLENBQU9DLEdBQVY7RUFBQTtBQUFBLGtPQUNYO0VBQUEsSUFBQztJQUFFQztFQUFGLENBQUQ7RUFBQSxPQUFjLElBQUFDLFVBQUEsRUFBSUQsSUFBSixDQUFkO0FBQUEsQ0FEVyxFQUVWO0VBQUEsSUFBQztJQUFFQTtFQUFGLENBQUQ7RUFBQSxPQUFjLElBQUFDLFVBQUEsRUFBSUQsSUFBSixDQUFkO0FBQUEsQ0FGVSxFQVlUO0VBQUEsSUFBQztJQUFFQTtFQUFGLENBQUQ7RUFBQSxPQUFjLElBQUFDLFVBQUEsRUFBSUQsSUFBSixDQUFkO0FBQUEsQ0FaUyxDQUFmOzs7QUF3QkEsTUFBTUUsWUFBWSxHQUFHLElBQUFKLHlCQUFBLEVBQU9LLG9CQUFQLENBQUg7RUFBQTtBQUFBLCtCQUFsQiJ9